import clsx from 'clsx';
import useMathRender from 'core/hooks/useMathRender';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

const TextRich = ({ className, id, onClick, text, title }) => {
  const rootNode = useRef(null);
  useMathRender(rootNode, [text]);

  return <div ref={rootNode} id={id} dangerouslySetInnerHTML={{ __html: text }} className={clsx('text-html', className)} onClick={onClick} title={title} />;
};

TextRich.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
};

TextRich.defaultProps = {
  id: 'useMathRender',
  onClick: () => {},
  text: '',
};

export default TextRich;
